import { useState } from "react";
import Whiteboard from "./Whiteboard";
import './Draw.css';

const Draw = ({ getDistanceEstimate }) => {
  const [drawing, setDrawing] = useState(null);
  const [isLoop, setIsLoop] = useState(true);
  const [hasDrawing, setHasDrawing] = useState(false);

  return (
    <div id='draw' className='inner-container'>
      <div className='title'>Draw Your Route</div>

      <div className='bump-out'>
        <Whiteboard setDrawingState={setDrawing} setHasDrawing={setHasDrawing}></Whiteboard>

        <div className='text'>
          Loop?{" "}
          <input
            type="checkbox"
            checked={isLoop}
            onChange={(e) => setIsLoop(e.target.checked)}
          />
        </div>

        <div>
          <button className='button-74' type="button" disabled={!hasDrawing} onClick={() => getDistanceEstimate(drawing, isLoop)}>Next</button>
        </div>
      </div>
    </div>
  )
}

export default Draw;